<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
        (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in">Disassociate Vendors</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <app-delete-entity
                entity="buVendorRelationship"
                [buVendorInfo]="buVendorsInfo"
                [deleteNote]="''"
                [sourceScreen]="'VENDOR_MANAGEMENT'"
                (cancelCallback)="closeModal()"
                (deleteCallback)="onDisassociateVendors()">
            </app-delete-entity>
        </div>
    </div>
</div>
